import { DynamicInput, Form } from '@domain-group/suit-theme'

import usePortalDataInput from '../../hooks/usePortalDataInput'

const getCurrentValue = (inputType: string, value: string, defaultValue: string) => {
  if (inputType === 'bool'){
    return typeof value === 'undefined' || value === '' ? defaultValue : value
  }

  if (inputType === 'select'){
    return value || defaultValue
  }

  return value
}

const PortalDataInput = (props: { fieldKey: string, marginTop?: (string | number)[] | string, style?: object }) => {
  const { fieldKey, marginTop, style } = props

  const inputPayload = usePortalDataInput(fieldKey)
  const {
    conditionsValid,
    defaultValue,
    dataStoreItemFormPayload: {
      entityState: { value },
      handlers,
    },
    fieldSchema: {
      inputComponent, inputType, label, values, valueType,
    },
  } = inputPayload

  // Don't render the field if it didn't pass validation conditions
  // e.g. only display commercial categories if listing type is commercial
  if (!conditionsValid){
    return null
  }

  return (
    // @ts-expect-error TS2322
    <Form.Field label={label || fieldKey} marginTop={marginTop}>
      <DynamicInput
        // @ts-expect-error TS2345
        currentValue={getCurrentValue(inputComponent, value, defaultValue)}
        // @ts-expect-error TS2322
        inputComponent={inputComponent}
        // @ts-expect-error TS2322
        inputType={inputType}
        name="value"
        placeholder={defaultValue}
        // @ts-expect-error TS2322
        style={style}
        // @ts-expect-error TS2322
        valueType={valueType}
        values={values}
        {...handlers}
      />
    </Form.Field>
  )
}

export default PortalDataInput
